import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-params-update',
  templateUrl: './params-update.component.html',
  styleUrls: ['./params-update.component.css']
})
export class ParamsUpdateComponent implements OnInit {

  form: any | FormGroup
  paramData:any = []

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getParamsData()
    this.form = this.fb.group({
      key: [''],
      value: ['']
    })  
  }

  update(){
    let body = {
      "key": String(this.form.get('key').value),
      "value": String(this.form.get('value').value),
    }
    this.generic_service.updatedUserParamValueForAllUsers(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success(response.message)
        this.form.reset()
      },
      (error:any)=> {
        console.log(error)
      }
    )
  }

  getParamsData(){
    this.generic_service.getParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

}

